import React from 'react';
import { Link } from 'react-router-dom';

export function DashboardPanel(props) {

    const setFormStatus = props.setFormStatus;

	React.useEffect(() => {
		console.log("setformstatus")
		setFormStatus(
			{
				message: "",
			})
	}, [setFormStatus]);

	return (
		<div className="dashboard-panel">
			<h1>Dashboard</h1>
			<Link className="dashboard-button" to="/notepad">Notepad</Link>
			<Link className="dashboard-button" to="/Contacts_Dave">davekirkwood.net</Link>
			<Link className="dashboard-button" to="/Contacts_Katsia">katyakirkwood.com</Link>
			<Link className="dashboard-button" to="/Users_Katsia">katyakirkwood.com Users</Link>
		</div>
	);
}
